import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useQuery } from "react-query";

interface UsageLimits {
  recording_limit_reached: boolean;
  streaming_limit_reached: boolean;
}

export const useLiveStreamsUsageLimits = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { currentCommunityMember } = usePunditUserContext();
  const canFetchUsageLimits = !!currentCommunityMember;
  const { data: usageLimits, isPending } = useQuery<UsageLimits>({
    queryKey: [internalApi.liveStreams.usageLimit()],
    enabled: enabled && canFetchUsageLimits,
  });

  return {
    isPending,
    isMonthlyHourLimitReached: usageLimits?.streaming_limit_reached,
    isStorageLimitReached: usageLimits?.recording_limit_reached,
  };
};
